module.exports = {
  DEFAULT_PROJECTION: 'mercator',
  DEFAULT_STYLE: 'Park Tiles Standard',
  DEFAULT_DARK_FEATURE_COLOR: '#f00',
  DEFAULT_LIGHT_FEATURE_COLOR: '#e8e8e8',
  DEFAULT_SATELLITE_FEATURE_COLOR: '#00f900'
};
